export default __webpack_public_path__ + "static/media/threatanalysis.d9d06ff4.png";